import { render, staticRenderFns } from "./u-tit-subtit.vue?vue&type=template&id=32522bd6&scoped=true&"
import script from "./u-tit-subtit.vue?vue&type=script&lang=js&"
export * from "./u-tit-subtit.vue?vue&type=script&lang=js&"
import style0 from "./u-tit-subtit.vue?vue&type=style&index=0&id=32522bd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32522bd6",
  null
  
)

export default component.exports